/**
 * useRecurrence — hook for accessing recurrence data for a task/template.
 */

import { useLiveQueryImmediate } from "@/db/hooks"
import { db } from "@/db/schema"
import type { DbRecurrence } from "@totodo/operations"

/**
 * Get the recurrence config for a template task.
 * Returns undefined if the task has no recurrence.
 */
export function useRecurrence(templateId: string | undefined): DbRecurrence | undefined {
  const [result] = useLiveQueryImmediate(
    () => (templateId ? db.recurrence.get(templateId) : undefined),
    ["recurrenceConfig", templateId],
    undefined,
  )
  return result
}

/**
 * Get instance count for a template (active, unfinished instances).
 */
export function useOpenInstanceCount(templateId: string | undefined): number {
  const [result] = useLiveQueryImmediate(
    () => {
      if (!templateId) return 0
      return db.totodo
        .where("recurringTemplateId")
        .equals(templateId)
        .filter(t => t.status === 0 && !t.isDeleted)
        .count()
    },
    ["openInstanceCount", templateId],
    0,
  )
  return result
}
